import React from 'react';
import { LayoutDashboardIcon, CalendarIcon, UsersIcon, FileTextIcon, BriefcaseIcon } from 'lucide-react';
import { usePermissions } from '../../hooks/usePermissions';
import { ModulePermissions } from '../../types';
const MAIN_TABS: {
  id: string;
  label: string;
  icon: React.ElementType;
  permission: keyof ModulePermissions;
}[] = [{
  id: 'dashboard',
  label: 'Panel',
  icon: LayoutDashboardIcon,
  permission: 'dashboard'
}, {
  id: 'appointments',
  label: 'Citas',
  icon: CalendarIcon,
  permission: 'appointments'
}, {
  id: 'patients',
  label: 'Pacientes',
  icon: UsersIcon,
  permission: 'patients'
}, {
  id: 'clinical-history',
  label: 'Historial',
  icon: FileTextIcon,
  permission: 'clinicalHistory'
}, {
  id: 'services',
  label: 'Servicios',
  icon: BriefcaseIcon,
  permission: 'services'
}];
interface BottomNavProps {
  currentModule: string;
  onModuleChange: (module: string) => void;
  onOpenMenu: () => void;
  isMenuOpen: boolean;
}
export function BottomNav({
  currentModule,
  onModuleChange,
  onOpenMenu,
  isMenuOpen
}: BottomNavProps) {
  const {
    canView
  } = usePermissions();
  const visibleTabs = MAIN_TABS.filter(t => canView(t.permission));
  return <nav className="bottom-nav-bar fixed bottom-0 left-0 right-0 z-40 md:hidden" style={{
    paddingBottom: 'env(safe-area-inset-bottom)'
  }} data-id="element-123">
      
      {/* Blur backdrop */}
      <div className="absolute inset-0 bg-white/90 dark:bg-gray-900/90 backdrop-blur-md border-t border-gray-200/80 dark:border-gray-700/80" data-id="element-124" />

      <div className="relative flex items-stretch h-14" data-id="element-125">
        {visibleTabs.map(tab => {
        const Icon = tab.icon;
        const isActive = currentModule === tab.id && !isMenuOpen;
        return <button key={tab.id} onClick={() => onModuleChange(tab.id)} className="flex-1 flex flex-col items-center justify-center gap-0.5 relative transition-all duration-150" data-id="element-126">
              
              {isActive && <div className="absolute inset-x-3 top-1.5 h-7 bg-teal-50 dark:bg-teal-900/40 rounded-xl" data-id="element-127" />}
              <Icon className={`w-5 h-5 relative z-10 transition-all duration-150 ${isActive ? 'text-teal-600 dark:text-teal-400 scale-110' : 'text-gray-400 dark:text-gray-500'}`} data-id="element-128" />
              
              <span className={`text-[10px] font-medium relative z-10 transition-colors duration-150 ${isActive ? 'text-teal-600 dark:text-teal-400' : 'text-gray-400 dark:text-gray-500'}`} data-id="element-129">
                
                {tab.label}
              </span>
            </button>;
      })}
      </div>
    </nav>;
}